export enum Theme {
  system = "system",
  day = "day",
  night = "night"
}
